@for (keyValue of keyValues; track keyValue) {
  <div class="form-check mb-2">
    <label class="form-check-label">
      <input
        class="form-check-input"
        type="checkbox"
        (change)="toggleValue(keyValue.key)"
        [checked]="selectedValues?.has(keyValue.key)">
      {{ keyValue.value | htmlDecode }}
      <div class="badge bg-gray-100 text-gray-700 fw-normal">{{ keyValue.count | number }}</div>
    </label>
  </div>
}

